export enum AnalyticsTela {
    OrdemServico = "Ordem de Serviço",
    VincularNF = "Vincular NF",
    Home = "Home",
    ProgramacaoNavios = "Programação de Navios",
    Cotacao = "Cotação",
    Booking = "Booking",
    Rastreamento = "Rastreamento",
    Documentacao = "Documentação"
}